import React from 'react'
import moment from 'moment'
import classnames from 'classnames'
import { withStyles, IconButton, Box } from '@material-ui/core'
import MonthSelector from 'Components/MonthSelector'
import { Select } from 'Components/Form/Select'
import { SortUpIcon } from '../../../../Assets/Images/icons/SortUpIcon'

import style from './style.js'

const DashboardsFilters = ({
  classes,
  filters = [],
  sortingOptions = [],
  selectedFilters = {},
  sortByValue,
  handleFiltersChange,
  handleSortingChange,
  isSelfServeEnabled,
  clearAllFilters,
  handleSortDirectionChange,
  sortDirection,
  disableSortDirection,
  isDmEnabled,
}) => {
  const renderFilter = filter => {
    switch (filter.type) {
      case 'month':
        return (
          <MonthSelector
            key={filter.key}
            title={filter.label}
            onChange={value =>
              handleFiltersChange(
                filter.key,
                filter.label,
                value === 'All'
                  ? null
                  : moment(value)
                      .endOf('month')
                      .format('YYYY-MM-DDTHH:mm:ssZ'),
              )
            }
            value={selectedFilters[filter.key] || null}
            disabled={filter.disabled}
          />
        )
      case 'select':
        return (
          <div key={filter.label + 'div'} className={classes.selectWrapper}>
            {!filter.withoutLabel && filter.label && (
              <label className={classes.label} cypress_id={'filterTitle'}>
                {filter.label}
              </label>
            )}
            <Select
              key={filter.key}
              options={filter.options}
              name={filter.key}
              value={selectedFilters[filter.key] || null}
              multiple={filter.multiple}
              listSubheaders={
                filter.multiple
                  ? filter.options.filter(option => option.isListSubheader)
                  : []
              }
              onChange={(e, i, value) =>
                handleFiltersChange(filter.key, filter.label, value)
              }
              minWidth="100%"
              cypress_id={'filterSelect'}
            />
          </div>
        )
      default:
        break
    }
  }
  return (
    <Box
      className={classnames(
        classes.filtersWrapper,
        {
          [classes.removeMarginBottom]: !isSelfServeEnabled,
        },
        'DashboardsFilters-filtersWrapper',
      )}
    >
      {filters.map(filter => renderFilter(filter))}
      {/* <span
        onClick={clearAllFilters}
        className={classes.clearButton}
        cypress_id={'clearFiltersBtn'}
      >
        Clear filters
      </span> */}

      {sortingOptions && sortingOptions.length ? (
        <div
          className={classnames(
            classes.sortWrapper,
            {
              [classes.eddmSortWrapper]: isDmEnabled,
            },
            'DashboardsFilters-sortWrapper',
          )}
        >
          <div className={classes.selectWrapper}>
            <label className={classes.label} cypress_id={'filterTitle'}>
              Sort by
            </label>
            <Select
              options={sortingOptions}
              value={sortByValue}
              onChange={(e, i, value) => handleSortingChange(value)}
              minWidth="100%"
              cypress_id={'filterSelect'}
            />
          </div>
          <IconButton
            onClick={handleSortDirectionChange}
            disabled={disableSortDirection}
            style={{ border: 'solid 1px #E2E2FC', borderRadius: '4px' }}
          >
            <SortUpIcon
              className={classnames({ [classes.rotate]: sortDirection })}
              disabled={disableSortDirection}
              cypress_id={'sortIcon'}
            />
          </IconButton>
        </div>
      ) : null}
    </Box>
  )
}

export default withStyles(style)(DashboardsFilters)
